import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withLocales } from 'react-localized';
var CompDecoratedFunctional = function (_a) {
    var ngettext = _a.ngettext;
    return (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["1 ", ngettext('apple', 'apples', 1)] }), _jsxs("p", { children: ["2 ", ngettext('apple', 'apples', 2)] }), _jsxs("p", { children: ["5 ", ngettext('apple', 'apples', 5)] })] }));
};
var CompDecoratedFunctionalWithLocales = withLocales()(CompDecoratedFunctional);
export default CompDecoratedFunctionalWithLocales;
